import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        redirect:"/caidan"
    },
    //首页菜单
    {
        path: '/caidan',
        name: "caidan",
        component:() => import('../views/Caidan.vue'),
    },
    //污水污泥登录
    {
        path: '/sign',
        name: "sign",
        component:() => import('../views/Sign.vue'),
    },
    //污水污泥注册
    {
        path: "/zhuce",
        name: "Zhuce",
        component: () => import("../views/Zhuce.vue"),
    },
    //饲料注册
    {
        path: "/zhuce2",
        name: "Zhuce2",
        component: () => import("../views/Zhuce2.vue"),
    },
    {
        path: "/shen",
        name: "Shen",
        component: () => import("../views/Shen.vue"),
    },
    //污水污泥装车录入
    {
        path: "/menu",
        name: "Menu",
        component: () => import("../views/Menu.vue"),
    },
    //饲料装车录入
    {
        path: "/menu2",
        name: "Menu2",
        component: () => import("../views/Menu2.vue"),
    },

    //环保巡查
    {
        path: "/huanbao",
        name: "Huanbao",
        component: () => import("../views/Huanbao.vue"),
    },
    //油耗录入
    {
        path: "/nbc",
        name: "Nbc",
        component: () => import("../views/Nbc.vue"),
    },
    //车辆用油
    {
        path: "/clyy",
        name: "Clyy",
        component: () => import("../views/Clyy.vue"),
    },
    //车辆尿素
    {
        path: "/clns",
        name: "Clns",
        component: () => import("../views/Clns.vue"),
    },
    //生产领用
    {
        path: "/scly",
        name: "Scly",
        component: () => import("../views/Scly.vue"),
    },
    //其他拥有
    {
        path: "/qtyy",
        name: "Qtyy",
        component: () => import("../views/Qtyy.vue"),
    },
    //报表登录
    {
        path: "/bblogin",
        name: "Bblogin",
        component: () => import("../views/Bblogin.vue"),
    },
    //报表菜单
    {
        path: "/bbcaidan",
        name: "Bbcaidan",
        component: () => import("../views/Bbcaidan.vue"),
    },
    //报表菜单
    {
        path: "/jzmx",
        name: "Jzmx",
        component: () => import("../views/Jzmx.vue"),
    },
    //车辆报表
    {
        path: "/bbhome",
        name: "Bbhome",
        component: () => import("../views/Bbhome.vue"),
    },
    //车辆报表明细
    {
        path: "/bblist",
        name: "Bblist",
        component: () => import("../views/Bblist.vue"),
    },
    {
        path: "/bblist2",
        name: "Bblist2",
        component: () => import("../views/Bblist2.vue"),
    },
   
    // 油卡报表
    {
        path: "/bbyk",
        name: "Bbyk",
        component: () => import("../views/Bbyk.vue"),
    },
    // 油卡报表明细1
    {
        path: "/bbyklist",
        name: "Bbyklist",
        component: () => import("../views/Bbyklist.vue"),
    },
    // 油卡报表明细2
    {
        path: "/bbyklist2",
        name: "Bbyklist2",
        component: () => import("../views/Bbyklist2.vue"),
    },

    // 死猪上传
    {
        path: "/upsizhu",
        name: "Upsizhu",
        component: () => import("../views/Upsizhu.vue"),
    },

     // 行驶上传
     {
        path: "/xsjl",
        name: "Xsjl",
        component: () => import("../views/Xsjl.vue"),
    },

    //猪粪运载
    {
        path: "/zfyz",
        name: "Zfyz",
        component: () => import("../views/Zfyz.vue"),
    },

    //所有车辆
    {
        path: "/allcar",
        name: "Allcar",
        component: () => import("../views/Allcar.vue"),
    },

     //投诉
     {
        path: "/complaint",
        name: "Complaint",
        component: () => import("../views3/Complaint.vue"),
    },

     //投诉2
    {
        path: "/complaint2",
        name: "Complaint2",
        component: () => import("../views3/Complaint2.vue"),
    },

      //食堂
      {
        path: "/canteen",
        name: "Canteen",
        component: () => import("../views3/Canteen.vue"),
    },

     //食堂
     {
        path: "/shitang1",
        name: "Shitang1",
        component: () => import("../views3/Shitang1.vue"),
    },


     //食堂
     {
        path: "/shitang2",
        name: "Shitang2",
        component: () => import("../views3/Shitang2.vue"),
    },
       //食堂
    {
        path: "/stpf",
        name: "Stpf",
        component: () => import("../views3/Stpf.vue"),
    },
    {
        path: "/feedback",
        name: "Feedback",
        component: () => import("../views3/Feedback.vue"),
    },
    {
        path: "/shd",
        name: "Shd",
        component: () => import("../views3/Shd.vue"),
    },


    //后台
    {
        path: "/login",
        name: "Login",
        component: () => import("../views2/Login.vue"),
    },
    {
        path: '/home',
        name: 'Home',
        component:() => import('../views2/Home.vue'),
        children:[
             {
                path:"/flag",
                name: 'Flag',
                component:() => import('../views2/Flag.vue'),
                meta:{pathname:"主页",name:"华统后台管理"}
            },
            {
                path:"/index",
                name: 'Index',
                component:() => import('../views2/Index.vue'),
                meta:{pathname:"主页",name:"污水污泥"}
            },
            // 饲料
            {
                path:"/siliao",
                name: 'Siliao',
                component:() => import('../views2/Siliao.vue'),
                meta:{pathname:"主页",name:"饲料"}
            },


            // 审核
            {
                path:"/shenhe",
                name: 'Shenhe',
                component:() => import('../views2/Shenhe.vue'),
                meta:{pathname:"审核",name:"污水污泥司机审核"}
            },

            // 饲料审核
            {
                path:"/shenhe2",
                name: 'Shenhe2',
                component:() => import('../views2/Shenhe2.vue'),
                meta:{pathname:"审核",name:"饲料司机审核"}
            },

             // 死猪
             {
                path:"/sizhuadmin",
                name: 'Sizhuadmin',
                component:() => import('../views2/Sizhuadmin.vue'),
                meta:{pathname:"死猪",name:"死猪"}
            },

            // 环保
            {
                path:"/huanbaoadmin",
                name: 'Huanbaoadmin',
                component:() => import('../views2/Huanbaoadmin.vue'),
                meta:{pathname:"环保",name:"环保"}
            },

             // 行驶记录
             {
                path:"/xsjladmin",
                name: 'Xsjladmin',
                component:() => import('../views2/Xsjladmin.vue'),
                meta:{pathname:"行驶记录",name:"行驶记录"}
            },

              // 猪粪运载
              {
                path:"/zfyzadmin",
                name: 'Zfyzadmin',
                component:() => import('../views2/Zfyzadmin.vue'),
                meta:{pathname:"猪粪运载",name:"猪粪运载"}
            },

            //油耗
            {
                path:"/cladmin",
                name: 'Cladmin',
                component:() => import('../views2/Cladmin.vue'),
                meta:{pathname:"油耗",name:"车辆用油"}
            },
            {
                path:"/yhdb",
                name: 'Yhdb',
                component:() => import('../views3/Yhdb.vue'),
                meta:{pathname:"油耗",name:"油耗核销"}
            },
            {
                path:"/clnsadmin",
                name: 'Clnsadmin',
                component:() => import('../views2/Clnsadmin.vue'),
                meta:{pathname:"油耗",name:"车用尿素"}
            },
            {
                path:"/scadmin",
                name: 'Scadmin',
                component:() => import('../views2/Scadmin.vue'),
                meta:{pathname:"油耗",name:"生产领用"}
            },
            {
                path:"/qtadmin",
                name: 'Qtadmin',
                component:() => import('../views2/Qtadmin.vue'),
                meta:{pathname:"油耗",name:"其他用油"}
            },
            {
                path:"/kucun",
                name: 'Kucun',
                component:() => import('../views2/Kucun.vue'),
                meta:{pathname:"油耗",name:"油量库存"}
            },

            // 后台管理员
            {
                path:"/carlist",
                name: 'Carlist',
                component:() => import('../views2/Carlist.vue'),
                meta:{pathname:"系统维护",name:"车辆维护"}
            },
            {
                path:"/wages",
                name: 'Wages',
                component:() => import('../views2/Wages.vue'),
                meta:{pathname:"系统维护",name:"工资维护"}
            },
            {
                path:"/yklist",
                name: 'Yklist',
                component:() => import('../views2/Yklist.vue'),
                meta:{pathname:"系统维护",name:"油卡维护"}
            },
            {
                path:"/yklist2",
                name: 'Yklist2',
                component:() => import('../views2/Yklist2.vue'),
                meta:{pathname:"系统维护",name:"主卡维护"}
            },
            {
                path:"/khadmin",
                name: 'Khadmin',
                component:() => import('../views2/Khadmin.vue'),
                meta:{pathname:"系统维护",name:"客户维护"}
            },
            {
                path:"/useradmin",
                name: 'Useradmin',
                component:() => import('../views2/Useradmin.vue'),
                meta:{pathname:"系统维护",name:"管理员维护"}
            },
            {
                path:"/power",
                name: 'Power',
                component:() => import('../views2/Power.vue'),
                meta:{pathname:"系统维护",name:"权限维护"}
            },

            //投诉2
            {
                path: "/tousufankui",
                name: "Tousufankui",
                component: () => import("../views3/Tousufankui.vue"),
                meta:{pathname:"投诉反馈",name:"投诉反馈"}
            },

             //食堂
            {
                path: "/shitang11",
                name: "Shitang11",
                component: () => import("../views3/Shitang11.vue"),
                meta:{pathname:"食堂评选",name:"菜单评选"}
            },
              //食堂
              {
                path: "/shitang12",
                name: "Shitang12",
                component: () => import("../views3/Shitang12.vue"),
                meta:{pathname:"食堂评选",name:"菜单留言"}
            },
              //食堂
             {
                path: "/shitang13",
                name: "Shitang13",
                component: () => import("../views3/Shitang13.vue"),
                meta:{pathname:"食堂评选",name:"物资评选"}
            },
               //食堂
               {
                path: "/shitangpf",
                name: "Shitangpf",
                component: () => import("../views3/Shitangpf.vue"),
                meta:{pathname:"食堂评选",name:"满意度调查"}
            },
           
            //股东回馈
              {
                path: "/gdhk1",
                name: "Gdhk1",
                component: () => import("../views3/Gdhk1.vue"),
                meta:{pathname:"股东回馈",name:"机构持股"}
            },
            {
                path: "/gdhk2",
                name: "Gdhk2",
                component: () => import("../views3/Gdhk2.vue"),
                meta:{pathname:"股东回馈",name:"个人持股"}
            },
        ]
    },
]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})
  
const VueRouterPush = VueRouter.prototype.push

VueRouter.prototype.push = function push (to) {
    return VueRouterPush.call(this, to).catch(err => err)
}
  
  
  
export default router


